<template>
    <div
        v-if="obj_to_null(cur_item)"
        class="categ_info"
    >
        <info_field
            f_uniq="cid"
            :f_title="__t('UNIQ_GO_CODE')"
            :f_val="cur_item.id.toString()"
        ></info_field>

        <info_field
            f_type="uniq_id"
            f_uniq="cid2"
            :f_title="__t('UNIQ_CODE')"
            :f_val="cur_item.uniq_id.toString()"
            @update_categ="change_atr"
        ></info_field>

        <!-- Google actions -->
        <div
            v-if="is_google_review"
            class="google_actions mb-4"
        >
            <div class="d-flex">
                <a
                    v-if="google_location_url"
                    :href="google_location_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-sm btn-outline-primary mr-2"
                >
                    <i class="fab fa-google mr-1"></i>
                    {{ __t('OPEN_GOOGLE_LOCATION') }}
                </a>

                <a
                    v-if="google_review_url"
                    :href="google_review_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-sm btn-outline-info"
                >
                    <i class="fal fa-comment-alt mr-1"></i>
                    {{ __t('OPEN_GOOGLE_REVIEW') }}
                </a>
            </div>
        </div>

        <!-- Ответ на отзыв -->
        <div
            v-if="has_reply"
            class="reply_action mb-4"
        >
            <div
                v-if="has_successful_reply && !is_reply_form_open"
                class="alert alert-success mb-3"
            >
                <div class="d-flex align-items-center mb-2">
                    <i class="fal fa-check-circle mr-2"></i>

                    <strong>
                        {{ __t('REPLY_ALREADY_SENT') }}
                    </strong>
                </div>

                <div
                    v-if="original_reply_text"
                    class="reply_existing_text"
                >
                    {{ original_reply_text }}
                </div>
            </div>

            <button
                type="button"
                class="btn btn-md btn-block btn-outline-info waves-effect waves-themed"
                :disabled="is_reply_load"
                @click="make_reply"
            >
                <span
                    class="fal mr-1"
                    :class="
                        is_reply_form_open
                            ? 'fa-times'
                            : 'fa-reply'
                    "
                ></span>

                {{
                    is_reply_form_open
                        ? __t('CANCEL')
                        : (
                            has_successful_reply
                                ? __t('UPDATE_REPLY')
                                : __t('REPLY')
                        )
                }}
            </button>

            <div
                v-if="is_reply_form_open"
                class="reply_form mt-3"
            >
                <div class="form-group mb-2">
                    <label class="form-label">
                        {{ __t('REPLY_TO_REVIEW') }}
                    </label>

                    <textarea
                        v-model="reply_text"
                        class="form-control"
                        rows="5"
                        maxlength="4096"
                        :disabled="is_reply_load"
                        :placeholder="__t('ENTER_REVIEW_REPLY')"
                    ></textarea>

                    <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">
                            {{ reply_text.length }} / 4096
                        </small>

                        <small
                            v-if="has_successful_reply"
                            class="text-success"
                        >
                            <i class="fal fa-check-circle mr-1"></i>
                            {{ __t('REPLY_ALREADY_SENT') }}
                        </small>
                    </div>
                </div>

                <button
                    type="button"
                    class="btn btn-primary btn-block waves-effect waves-themed"
                    :disabled="!can_send_reply"
                    @click="send_reply"
                >
                    <span
                        v-if="is_reply_load"
                        class="spinner-border spinner-border-sm mr-1"
                        role="status"
                    ></span>

                    <span
                        v-else
                        class="fal fa-paper-plane mr-1"
                    ></span>

                    {{
                        has_successful_reply
                            ? __t('UPDATE_REPLY')
                            : __t('SEND_REPLY')
                    }}
                </button>
            </div>
        </div>

        <info_field
            f_uniq="customer_name"
            :f_title="__t('AUTHOR')"
            :f_val="cur_item.customer_name.toString()"
        ></info_field>

        <info_field
            f_uniq="customer_phone"
            :f_title="__t('PHONE')"
            :f_val="cur_item.customer_phone.toString()"
        ></info_field>

        <info_field
            f_uniq="ratio"
            :f_title="__t('RATIO')"
            :f_val="cur_item.ratio.toString()"
        ></info_field>

        <div class="form-group">
            <label
                class="form-label"
                for="review-comment"
            >
                {{ __t('COMMENT') }}
            </label>

            <div class="input-group">
                <textarea
                    id="review-comment"
                    v-model="cur_item.description"
                    disabled
                    class="form-control"
                    rows="7"
                    aria-label="Review comment"
                ></textarea>
            </div>
        </div>

        <info_field
            f_uniq="source"
            :f_title="__t('SOURCE')"
            :f_val="source_name"
        ></info_field>

        <div class="form-group">
            <label
                class="form-label"
                for="review-date"
            >
                {{ __t('DATE_CREATE') }}
            </label>

            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text text-success">
                        <i class="fal fa-calendar-edit fs-xl"></i>
                    </span>
                </div>

                <input
                    id="review-date"
                    v-model="cur_item.added"
                    type="text"
                    class="form-control"
                    disabled
                >
            </div>
        </div>
    </div>
</template>

<script>
import Info_field from "../../../../sys/info_field";

export default {
    name: "review_tab_info",

    components: {
        Info_field
    },

    props: {
        org: {
            type: Object,

            default() {
                return {};
            }
        }
    },

    data() {
        return {
            cur_item: this.org || {},

            is_reply_load: false,
            is_reply_form_open: false,

            reply_text: "",
            original_reply_text: ""
        };
    },

    watch: {
        org: {
            immediate: true,

            handler(value) {
                this.cur_item = value || {};

                this.set_existing_reply();
            }
        }
    },

    methods: {
        change_atr(atr_name, atr_val) {
            if (
                this.cur_item &&
                this.cur_item.hasOwnProperty(atr_name)
            ) {
                this.$set(
                    this.cur_item,
                    atr_name,
                    atr_val
                );
            }
        },

        make_reply() {
            this.is_reply_form_open =
                !this.is_reply_form_open;

            if (this.is_reply_form_open) {
                this.set_existing_reply();
            }
        },

        get_last_successful_reply() {
            const replies = Array.isArray(
                this.cur_item.replies
            )
                ? this.cur_item.replies
                : [];

            for (
                let i = replies.length - 1;
                i >= 0;
                i--
            ) {
                const reply = replies[i];

                if (
                    reply &&
                    reply.status === "operation_success"
                ) {
                    return reply;
                }
            }

            return null;
        },

        set_existing_reply() {
            const reply =
                this.get_last_successful_reply();

            const text =
                reply &&
                typeof reply.reply_text === "string"
                    ? reply.reply_text
                    : "";

            this.reply_text = text;
            this.original_reply_text = text;
        },

        get_review_from_response(data) {
            if (
                !data ||
                typeof data !== "object"
            ) {
                return null;
            }

            /*
             * Вариант:
             *
             * {
             *     status: operation_success,
             *     data: {
             *         review: {...}
             *     }
             * }
             */
            if (
                data.data &&
                data.data.review &&
                typeof data.data.review === "object"
            ) {
                return data.data.review;
            }

            /*
             * Вариант:
             *
             * {
             *     status: operation_success,
             *     data: {
             *         id: ...
             *     }
             * }
             */
            if (
                data.data &&
                typeof data.data === "object" &&
                data.data.id
            ) {
                return data.data;
            }

            /*
             * Вариант:
             *
             * {
             *     review: {...}
             * }
             */
            if (
                data.review &&
                typeof data.review === "object"
            ) {
                return data.review;
            }

            return null;
        },

        update_review(review) {
            if (
                !review ||
                typeof review !== "object"
            ) {
                return;
            }

            Object.keys(review).forEach(key => {
                this.$set(
                    this.cur_item,
                    key,
                    review[key]
                );
            });
        },

        add_local_reply(reply_text) {
            const replies = Array.isArray(
                this.cur_item.replies
            )
                ? [...this.cur_item.replies]
                : [];

            replies.push({
                reply_text: reply_text,
                status: "operation_success"
            });

            this.$set(
                this.cur_item,
                "replies",
                replies
            );

            this.$set(
                this.cur_item,
                "has_successful_reply",
                true
            );
        },

        send_reply() {
            if (!this.can_send_reply) {
                return;
            }

            const reply =
                this.reply_text.trim();

            this.is_reply_load = true;

            review_api
                .post(
                    "/reviews/" +
                    parseInt(
                        this.cur_item.id
                    ) +
                    "/reply",
                    {
                        reply: reply
                    }
                )
                .then(({ data }) => {
                    if (
                        !data ||
                        data.status !==
                        "operation_success"
                    ) {
                        throw {
                            response: {
                                data: data || {}
                            }
                        };
                    }

                    const review =
                        this.get_review_from_response(
                            data
                        );

                    if (review) {
                        this.update_review(review);
                    } else {
                        this.add_local_reply(
                            reply
                        );
                    }

                    this.set_existing_reply();

                    this.is_reply_form_open =
                        false;

                    EventBus.$emit(
                        "show_toast",
                        {
                            err:
                                data.message ||
                                this.__t(
                                    "REPLY_SENT"
                                ),

                            type: "success",

                            title:
                                this.__t(
                                    "SUCCESS"
                                ),

                            position:
                                "b-toaster-top-left"
                        }
                    );

                    this.$emit(
                        "reply_sent",
                        {
                            review_id:
                            this.cur_item.id,

                            review:
                            this.cur_item,

                            reply:
                                this.get_last_successful_reply()
                        }
                    );
                })
                .catch(error => {
                    const response =
                        error.response || {};

                    const responseData =
                        response.data || {};

                    EventBus.$emit(
                        "show_toast",
                        {
                            err:
                                responseData.message ||
                                this.__t(
                                    "REPLY_SEND_ERROR"
                                ),

                            type: "danger",

                            title:
                                responseData.status ||
                                this.__t(
                                    "ERROR"
                                ),

                            position:
                                "b-toaster-top-left"
                        }
                    );
                })
                .finally(() => {
                    this.is_reply_load =
                        false;
                });
        }
    },

    computed: {
        source_name() {
            if (
                !this.cur_item ||
                !this.cur_item.source
            ) {
                return "";
            }

            if (
                typeof this.cur_item.source ===
                "string"
            ) {
                return this.cur_item.source;
            }

            return (
                this.cur_item.source.human_name ||
                this.cur_item.source.name ||
                this.cur_item.source.type ||
                ""
            ).toString();
        },

        source_type() {
            if (
                !this.cur_item ||
                !this.cur_item.source
            ) {
                return "";
            }

            if (
                typeof this.cur_item.source ===
                "string"
            ) {
                return this.cur_item.source;
            }

            return (
                this.cur_item.source.type ||
                this.cur_item.source.name ||
                ""
            );
        },

        is_google_review() {
            return (
                this.source_type ===
                "google_review" ||
                this.source_type ===
                "google"
            );
        },

        has_reply() {
            return Boolean(
                this.cur_item &&
                this.cur_item.has_reply
            );
        },

        has_successful_reply() {
            return Boolean(
                this.cur_item &&
                this.cur_item.has_successful_reply
            );
        },

        google_location_url() {
            if (
                !this.cur_item ||
                !this.cur_item.google
            ) {
                return "";
            }

            return (
                this.cur_item.google
                    .location_url || ""
            );
        },

        google_review_url() {
            if (
                !this.cur_item ||
                !this.cur_item.google
            ) {
                return "";
            }

            return (
                this.cur_item.google
                    .review_url || ""
            );
        },

        can_send_reply() {
            const reply =
                this.reply_text.trim();

            if (
                !this.has_reply ||
                this.is_reply_load ||
                reply.length === 0
            ) {
                return false;
            }

            if (
                this.has_successful_reply &&
                reply ===
                this.original_reply_text.trim()
            ) {
                return false;
            }

            return true;
        }
    }
};
</script>

<style scoped>
.reply_action {
    padding: 15px;
    background: #f8f9fa;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
}

.reply_form textarea {
    min-height: 110px;
    resize: vertical;
}

.reply_existing_text {

}

.google_actions {
    padding: 12px 15px;
    background: #f8f9fa;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
}
</style>
